import { api, baseUrl } from "../../api";

export const getUserLatestLocation = async (data: any) => {
  const res = await api.post(`${baseUrl}/admin/vehicle-api/single-track`, {
    data: data,
  });
  return res.data.data;
};
